export default "__VITE_ASSET__CLr9FkpV__"